import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
}
export class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
export class PasswordRevokedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "PasswordRevokedError";
    }
}
export class IdentityDisabledError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "IdentityDisabledError";
    }
}
export class NotAllowedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotAllowedError";
    }
}
export class InvalidRefreshTokenError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidRefreshTokenError";
    }
}
export class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
export class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
export class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
export class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
export default {
    GenericError,
    InvalidParameterError,
    PasswordRevokedError,
    IdentityDisabledError,
    NotAllowedError,
    InvalidRefreshTokenError,
    NotFoundError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
